module.exports = __webpack_public_path__ + "static/media/sgs.699d279a.jpg";